import { useContext } from 'preact/hooks';

import WidgetStateContext from '../context/WidgetState';

export function useWidgetState() {
	const context = useContext(WidgetStateContext);

	if (!context) {
		throw new Error('No WidgetStateContext.Provider found when calling useWidgetState.');
	}

	return context;
}
